import ProgressBar from "../../../../Components/ProgressBar";
import BillingDetailsContent from "./BillingDetailsContent";

import { store } from "../../../../../store"
import { useSelector, useDispatch } from "react-redux";
import { format, addMonths } from 'date-fns';
import { Animate } from "react-simple-animate";
import { sendCombined } from "../../../../../Features/Payment/paymentSlice";
import { incrementLoginStep } from "../../../../../Features/Misc/loginSlice";


import {
    createUser,
    grabToken,
    grabUserID,
    logIn,
    purgeID,
} from "../../../../../Features/Auth/authSlice";


export default function BillingDetails() {
    const dispatch = useDispatch()

    const {
        first_name,
        last_name,
        email,
        planType,
        kipMateCode,
        postcode,
        address_1,
        address_2,
        city,
        password,
        emailVerified,
        id,
        userType,
        hasActiveSubscription
    } = useSelector((state) => state.auth)
    const { authorisation_url } = useSelector((state) => state.payment)
    const { stripeCustomerId, paymentMethodId} = useSelector((state) => state.stripe)



    const variation_id = planType === 1 ? 118 : planType === 2 ? 119 : planType === 3 ? 120 : null;


    const userData = {
        first_name,
        last_name,
        email,
        password,
        userType,
        kipMateCode
    }


    const grabData = {
        email,
        password
    }

    const largeInputStyle = ` bg-pink-dashboard focus:outline-none border-white text-white rounded-lg border-2 h:16 sm:h-12 px-4 py-1 mb-2 `
    const subStyle =  `col-start-1 col-end-13 row-start-1 sm:row-start-3  row-end-13 flex text-xl text-white flex-col gap-0 sm:gap-2 `

    const loginData ={
        username: email,
        password
    }


    const kipmateCombined = {
        payment_method: "stripe",
        customer_id: id,
        email,

        line_items: [
            {
                product_id: 117,
                variation_id,
                quantity: 1,
            }
        ],
        billing: {
            first_name: first_name,
            last_name: last_name,
            address_1: address_1,
            address_2: address_2,
            city: city,
            postcode: postcode,
            country: "GB",
            email: email,
        },
        meta_data: [
            {
                key: "_stripe_customer_id",
                value: stripeCustomerId
            },
            {
                key: "_stripe_payment_method_id",
                value: paymentMethodId
            }
        ]

    }

    let monthsToAdd;

    switch (planType) {
        case 1:
            monthsToAdd = 1
            break;
        case 2:
            monthsToAdd = 3
            break;
        case 3:
            monthsToAdd = 12
            break;
        default:
            monthsToAdd = 1
            break;
    }


 let planText;
 let price;
 const startDate = format(new Date(), "dd/MM/yyyy");
 const endDate = format(addMonths(new Date(), monthsToAdd), "dd/MM/yyyy");


    switch(planType) {
        case 1:
            planText = "1 Month"
            price = "£15/month"
            break;
        case 2:
            planText =  "3 Monthly"
            price = "£10/month"
            break;
        case 3:
            planText = "Yearly"
            price = "£5/month"
            break;
        default:
            planText = "1 Month"
            price = "£15/month"
    }




    const handleSubmit = async (data) => {
        try {
            if (emailVerified === true) {
                await dispatch(purgeID);
                await dispatch(createUser(userData));
                await dispatch(grabUserID(grabData));
                const state = store.getState()
                const userId = state.auth.id;
                const combinedData = {...data, customer_id: userId}
                await dispatch(sendCombined(combinedData));


            } else {
                alert("Please verify your email");
            }
        } catch (error) {
            console.error(error);
            // Handle the error here
        }
    };

    const handleSubmit2 = async () => {
        try {
            if (emailVerified === true) {

                dispatch(incrementLoginStep())
                window.open(authorisation_url, "_blank")

            } else {
                alert("Please verify your email");
            }
        } catch (error) {
            console.error(error);
            // Handle the error here
        }
    };

    return (

        <div className={subStyle}>
            <Animate play start={{opacity: 0}} end={{opacity: 1, display: "flex", flexDirection: "column", gap: "1rem" }} duration={0.7} >

                <BillingDetailsContent
                    planText={planText}
                    price={price}
                    startDate={startDate}
                    endDate={endDate}
                    largeInputStyle={largeInputStyle}
                    handleSubmit={handleSubmit}
                    handleSubmit2={handleSubmit2}
                    kipmateCombined={kipmateCombined}
                />

                { !hasActiveSubscription && <ProgressBar width={"w-16"}/> }

                { hasActiveSubscription && <ProgressBar width={"w-20"}/> }

            </Animate>

        </div>

    );
}
